
	import Vue from "vue";

	export default Vue.extend({
		name: "LoginForm",
		data() {
			return {
				/**
				 * User object. Has username and password as key. Used for logging in.
				 **/
				user: {
					email: "",
					pwd: "",
				},
				/**
				 * Remember user and password for login.
				 **/
				rememberUser: false as boolean,
			};
		},
		methods: {
			/**
			 * Does login.
			 * @public
			 **/
			login() {
				/** Validates login form **/
				// eslint-disable-next-line
				const form: any = this.$refs.loginForm;
				if (form && form.validate()) {
					this.$emit("login", {
						email: this.user.email,
						password: this.user.pwd,
					});
				}
			},
			toRecoveryPassword() {
        window.open("https://web-staging.join-me.biz/", '_blank');
				// this.$emit("resetPassword");
			},
			reset() {
				const form: any = this.$refs.loginForm;
				if (form) {
					form.reset();
				}
			},
		},
		props: {
			/**
			 * Shows spinner when logging in
			 * @values true, false
			 */
			loading: {
				type: Boolean,
				default: false,
			},
		},
	});
